import styled from 'styled-components';

export const LimitContainer = styled.div`
  display: flex;
  align-items: center;

  label {
    margin-right: 15px;
  }
`;
